import React, { useState } from "react";
import { Box, Chip, CircularProgress, Fade, FormControl, IconButton, InputLabel, MenuItem, OutlinedInput, Select, TextField, Typography, Modal } from '@mui/material';
import EditorCustom from "../EditorCustorm/EditorCustom";
import LoadingButtonCustom from "../LoadingButtonCustom/LoadingButtonCustom";
import { useEffect } from "react";
import AttachFile from '@mui/icons-material/AttachFile';
import Close from '@mui/icons-material/Close';
import MailOutlined from '@mui/icons-material/MailOutlined';
import { useRef } from "react";
import { useSelector } from "react-redux";
import { sendEmailsToCandidatsOfSelection } from "../../services/SelectionCandidatService";
import { removeLineBreak } from "../../utils/EditorUtil";
import { withSnackbar } from "../../utils/SnackbarHOC";
import { useDispatch } from "react-redux";
import { setToggleMailing } from "../../redux/toggle/actions/toggleActions";
import { ClearListCandidatsSelectedForSelection } from "../../redux/candidats/actions/candidatsActions";
import {listEmailTypes} from "../../services/EmailTypeService";
import TagsInput from "../../utils/TagsInput";
import {getUserData} from "../../utils/FunctionHelpers";
import {getAllUsersForTasks, getDetails} from "../../services/UserService";
import { AppButton } from "../UI";

const paperStyle = {
  backgroundColor: '#fff',
  boxShadow: '0 20px 60px rgba(0,0,0,0.12)',
  padding: '24px 32px',
  borderRadius: '16px',
  width: '550px',
  maxWidth: '95vw',
  outline: 'none',
};

const modalSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

function MailingModal({ snackbarShowMessage }) {
  const [emailTypes, setEmailTypes] = useState([]);
  const [messageBody, setMessageBody] = useState("");
  const [cc, setCc] = useState([]);
  const [cci, setCci] = useState([]);
  const [objet, setObjet] = useState("");
  const uploadRef = useRef(null);
  const [dataUpload, setDataUpload] = useState();
  const [loadingToSend, setLoadingToSend] = useState(false);
  const [errors, setErrors] = useState({});
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [de, setDe] = useState(getUserData()?.uuid);
  const [users, setUsers] = useState([]);
  const selectedCandidatForSelection = useSelector(
    (state) => state.candidats.candidatsSelectedForSelection
  );
  const showMailingModal = useSelector((state) => state.toggle.showMailing);
  const dispatch = useDispatch();

  const handleSelectedCC = (ccs) => setCc(ccs);
  const handleSelectedCCI = (ccis) => setCci(ccis);
  const handleSignature = async (id) => {
    setDe(id);
    await getDetails(id);
  };

  useEffect(() => {
    if (!showMailingModal) return;

    setMessageBody("Bonjour [PRENOM],<br></br><p>Bien cordialement</p>");
    setErrors({});
    setLoadingUsers(true);

    let active = true;
    const fetchEmailTypes = async () => {
      try {
        const [response, usersResp] = await Promise.all([
          listEmailTypes(),
          getAllUsersForTasks(),
        ]);
        if (!active) return;
        setEmailTypes(response.data);
        setUsers(usersResp.data);
      } catch (error) {
        if (active) snackbarShowMessage("Erreur lors du chargement des types d'email.", "error", 4000);
      } finally {
        if (active) setLoadingUsers(false);
      }
    };

    fetchEmailTypes();
    return () => {
      active = false;
      setLoadingUsers(false);
    };
  }, [showMailingModal, snackbarShowMessage]);

  const validate = ({ messageBody, objet }) => {
    let temp = {};
    temp.commentaire = !(messageBody?.replace(/<\/?[^>]+(>|$)/g, "") === "")
      ? "" : "Le champ 'MESSAGE' est obligatoire.";
    temp.objet = !(objet?.replace(/<\/?[^>]+(>|$)/g, "") === "")
      ? "" : "Le champ 'OBJET' est obligatoire.";
    setErrors({ ...temp });
    return !Object.values({ ...temp }).some((error) => error !== "");
  };

  const handleSubmit = ({ messageBody, objet, pj }) => {
    if (validate({ messageBody, objet })) {
      (async () => {
        setLoadingToSend(true);
        const formData = new FormData();
        formData.append("de", de);
        if (cc.length > 0) cc.forEach(email => formData.append('cc[]', email));
        if (cci.length > 0) cci.forEach(email => formData.append('cci[]', email));
        formData.append("messageBody", removeLineBreak(messageBody));
        formData.append("objet", objet);
        formData.append("pj", pj);
        formData.append("selectedCandidatToSendMail", selectedCandidatForSelection);
        try {
          snackbarShowMessage("Patientez svp!", "warning", null);
          const response = await sendEmailsToCandidatsOfSelection(formData);
          snackbarShowMessage(response.data);
          dispatch(ClearListCandidatsSelectedForSelection());
        } catch (e) {
          snackbarShowMessage(e.response.data.error.detail, "error", 4000);
        } finally {
          setLoadingToSend(false);
          dispatch(setToggleMailing(false));
        }
      })();
    }
  };

  const editorCustomProps = {
    value: messageBody,
    setValue: setMessageBody,
    handleSubmit,
    enableOnBlur: false,
  };

  const loadingButtonProps = {
    handleSubmit: () => handleSubmit({ messageBody, objet, pj: dataUpload }),
    loading: loadingToSend,
    title: "Envoyer",
  };

  const body = (
    <Box sx={paperStyle} className="crm-modal--composer crm-mailing-composer">
      <Box className="crm-mailing-composer__header">
        <Box className="crm-mailing-composer__titleWrap">
          <Box className="crm-mailing-composer__icon">
            <MailOutlined fontSize="small" />
          </Box>
          <Box>
              <Typography className="crm-mailing-composer__title">
                Emailing
              </Typography>
          </Box>
        </Box>
        <IconButton
          aria-label="Fermer"
          onClick={() => {
            setDataUpload(null);
            dispatch(setToggleMailing(false));
          }}
          disabled={loadingToSend}
          size="small"
          className="crm-mailing-composer__close"
        >
          <Close fontSize="small" />
        </IconButton>
      </Box>
      <Box sx={{ paddingBottom: "16px" }} className="crm-modal__scrollArea">
        <Box className="crm-mailing-composer__callout">
          <MailOutlined fontSize="small" />
          <span>
            Préparez un email groupé clair, relisez l'objet et ajoutez une pièce jointe si nécessaire.
          </span>
        </Box>
        <label className="input-label" htmlFor="cci">DE</label>
        {loadingUsers ? (
          <Box display="flex" justifyContent="center"><CircularProgress /></Box>
        ) : (
          <FormControl variant="outlined" fullWidth margin="normal">
            <InputLabel {...(errors.de && { error: true })} shrink>
              {errors.de}
            </InputLabel>
            <Select
              value={de}
              name="users"
              onChange={(e) => handleSignature(e.target.value)}
              {...(errors.de && { error: true })}
              input={
                <OutlinedInput name="de" {...(errors.de && { labelWidth: 280 })} notched />
              }
            >
              {loadingUsers ? (
                <CircularProgress />
              ) : (
                users.map((user) => (
                  <MenuItem value={user.uuid} key={user.uuid}>
                    {`${user.nom} ${user.prenom} (${user.email})`}
                  </MenuItem>
                ))
              )}
            </Select>
          </FormControl>
        )}
        <label className="input-label" htmlFor="cci">CC</label>
        <TagsInput
          selectedTags={handleSelectedCC}
          fullWidth
          id="cc"
          name="cc"
          validation={/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/}
          placeholder="Ajouter des CC"
        />
        <label className="input-label" htmlFor="cci">CCI</label>
        <TagsInput
          selectedTags={handleSelectedCCI}
          fullWidth
          variant="outlined"
          id="cci"
          name="cci"
          placeholder="Ajouter des CCI"
        />
        <label className="input-label" htmlFor="emailType">Email Type</label>
        <Select
          onChange={(e) => {
            const selectedEmailType = emailTypes.find((type) => type.uuid === e.target.value);
            setObjet(selectedEmailType?.objet || "");
            setMessageBody(selectedEmailType?.message || "");
          }}
          value={emailTypes.find((type) => type.objet === objet)?.uuid || ""}
          fullWidth
          variant="outlined"
          displayEmpty
        >
          {[
            <MenuItem value="" key="-">-</MenuItem>,
            emailTypes
              .filter((type) => type.TypeMsg === "email")
              .map((type) => (
                <MenuItem key={type.uuid} value={type.uuid}>{type.msgName}</MenuItem>
              ))
          ]}
        </Select>
        <label className="input-label" htmlFor="prenom">
          Objet<span className="required-input">*</span>
        </label>
        <TextField
          onChange={(e) => setObjet(e.target.value)}
          name={objet}
          value={objet}
          placeholder="Objet du mail."
          margin="normal"
          variant="outlined"
          autoComplete="off"
          fullWidth
          {...(errors.objet && { error: true, label: errors.objet })}
        />
        <Box className="input-label">
          Message <span className="required-input">*</span>
        </Box>
        <EditorCustom {...editorCustomProps} />
        {errors.commentaire && (
          <Typography variant="body2" color="error">{errors.commentaire}</Typography>
        )}
        {dataUpload && (
          <Box sx={{ display: "flex", gap: "10px", alignItems: "center", height: "100%" }} className="input-label">
            <span>PJ:</span>
            <Chip
              label={dataUpload.name}
              variant="default"
              onDelete={() => setDataUpload(null)}
              size="small"
            />
          </Box>
        )}
      </Box>
      <Box className="crm-mailing-composer__footer">
        {!dataUpload && (
          <Box sx={{ display: "flex" }}>
            <input
              type="file"
              onChange={(e) => setDataUpload(e.target.files[0])}
              style={{ display: "none" }}
              ref={uploadRef}
            />
            <IconButton
              onClick={() => uploadRef.current.click()}
              data-toggle="tooltip"
              title="Ajouter PJ"
              sx={{ color: '#03407b' }}
            >
              <AttachFile style={{ fontSize: "20px" }} />
            </IconButton>
          </Box>
        )}
        <AppButton
          variant="secondary"
          onClick={() => {
            setDataUpload(null);
            dispatch(setToggleMailing(false));
          }}
          disabled={loadingToSend}
        >
          Annuler
        </AppButton>
        <LoadingButtonCustom {...loadingButtonProps} />
      </Box>
    </Box>
  );

  return (
    <Modal sx={modalSx} open={showMailingModal} closeAfterTransition>
      <Fade in={showMailingModal}>{body}</Fade>
    </Modal>
  );
}

export default withSnackbar(MailingModal);
